import React, { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import userQueries from '../../queries/userQueries';
import Loader from '../Loader/Loader';
import RichTextEditor from "../Rte/Rteeditor";
import { BASE_URL } from "../../apis/api";


const EditTestimonials = () => {
    const [susmsg, setSusmsg] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageUploadSuccess, setImageUploadSuccess] = useState(false);
    const [imageError, setImageError] = useState('');
    const [loading, setLoading] = useState(false);
    const imageRef = useRef(null);
    const [content, setContent] = useState('');
    const [contentError,setContentError] = useState('');
    const [currentImageUrl, setCurrentImageUrl] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    const { id } = useParams();
    const navigate = useNavigate();

    const { register, reset, handleSubmit, getValues,formState: { errors } } = useForm();

    const MAX_FILE_SIZE = 350 * 1024;

    const testimonialsdata = userQueries.useUpdatetestimonialsMutation(
        (response) => {
           
            if (response?.data) {
                let datas = ({
                    id: id,
                    name: response?.data.name,
                    content: response?.data.content,
                    status: response?.data.status,
                    displayorder: response?.data.displayorder
                });
                setContent(response?.data.content);
                reset({ ...datas });
                setCurrentImage(response?.data.photo || null);
                setCurrentImageUrl(response?.data.photo ? `${BASE_URL}/${response.data.photo}` : null);
            }
        }
    );

    useEffect(() => {
        testimonialsdata.mutateAsync({ id });
    }, [id]);

    const EditTestimonials = userQueries.useUpdatetestimonialsMutation(
        (response) => {
            if (response?.message === "Success") {
                setSusmsg(true);
                alert(response.data.status === 'Unpublish' ? "Saved as draft" : "Published successfully");
                navigate('/testimonialslist');
            }
            
        }
    );

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setSelectedImage(file);
            
            // Create a preview URL for the newly selected image
            const objectUrl = URL.createObjectURL(file);
            setPreviewUrl(objectUrl);
        }
    };

    const handleFormSubmit = async (data, publishStatus) => {
        setLoading(true);  // Disable buttons immediately after submitting
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if(selectedImage){
            if (!allowedTypes.includes(selectedImage.type)) {
                setImageError("Only JPEG, JPG and PNG files are allowed.");
                setLoading(false);  // Re-enable buttons if validation fails
                return false;
            }
        }
        if(publishStatus === 'Publish')
        {
            
            if (!content) {
                setImageError("");  // Clear image error
                setContentError("Content is required.");  // Set content error
                setLoading(false);
                return false;
            }
            
            else if(!selectedImage && !currentImage)
            {
                setImageError("Image Required");
                    setLoading(false);  // Re-enable buttons if validation fails
                    return false;
            }
        }

        const datavalues = {
            id: id,
            name: data.name,
            content: content,
            testimonials: selectedImage,
            status: publishStatus,
            displayorder: data.displayorder || 1

        };
    
        try {
            await EditTestimonials.mutateAsync(datavalues);
            
        } catch (error) {
            console.error("Error updating testimonials:", error);
        } finally {
            setLoading(false);  // Re-enable buttons after completion
        }
    };

    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);
    
    return (
        <>
            <h4 className="mb-6 text-xl font-semibold text-black dark:text-white">
                Update Testimonials
            </h4>
            <form className="max-w-lg mx-auto grid grid-cols-2 gap-4">
                <div className="mb-5 col-span-2">
                    <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
                    <input 
                        type="text" 
                        id="name" 
                        {...register("name", { required: "name is required" })} 
                        name="name" 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" 
                    />
                    {errors.name && <div className="text-red-600 text-s">{errors.name.message}</div>}
                </div>

                <div className="mb-5 col-span-2">
                    <label htmlFor="content" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Content <span className="text-sm text-gray-500"></span>
                    </label>
                    <RichTextEditor
                        onChange={(value) => setContent(value)}
                        name="content"
                        value={content}
                    />
                    {errors.content && <div className="text-red-600 text-s">{errors.content.message}</div>}
                </div>
                {contentError && <div className="text-red-600 text-s">{contentError}</div>}

                <div className="mb-5 col-span-2">
                    <label htmlFor="image" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Upload Image
                    </label>
                  {/* Image Preview Section */}
                  <div className="mb-4">
                        {(previewUrl || currentImageUrl) && (
                            <div className="relative w-48 h-48 mb-4">
                                <img
                                    src={previewUrl || currentImageUrl}
                                    alt="Speaker preview"
                                    className="w-full h-full object-cover rounded-lg shadow-md"
                                />
                            </div>
                        )}
                    </div>
                    <input
                        type="file"
                        id="image"
                        ref={imageRef}
                        onChange={handleImageChange}
                        accept="image/*"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    />
                    
                    {imageError && <div className="text-red-600 text-s">{imageError}</div>}
                    {imageUploadSuccess && (
                        <div className="mt-2 text-sm text-green-600">
                            Image uploaded successfully!
                        </div>
                    )}
                </div>
                <div className="mb-5">
                    <label htmlFor="displayorder" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Display Order</label>
                    <input 
                        type="number" 
                        id="displayorder" 
                        {...register("displayorder", { required: false })} 
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" 
                    />
                   
                </div>


                <button 
                    type="button"
                    onClick={() => handleFormSubmit(getValues(), 'Unpublish')}
                    className="col-span-2 w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-3"
                >
                    Save as draft
                </button>

                <button 
                    type="button"
                    onClick={handleSubmit((data) => handleFormSubmit(data, 'Publish'))}
                    className="col-span-2 w-full text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                    Save and publish
                </button>

                {susmsg && (
                    <div className="text-green-600 text-lg ml-6 text-center inline-block whitespace-nowrap col-span-2">
                        Testimonials updated successfully
                    </div>
                )}
            </form>
            {loading && (
                <Loader />  
            )}
        </>
    );
};

export default EditTestimonials;
